var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"page-periods"}},[_c('h5',{staticClass:"m-4 page-header"},[_vm._v(" >> "+_vm._s(_vm.$t('PERIOD.PERIODS')))]),_c('memlist-card',{staticClass:"mb-2",attrs:{"title":"","hide-footer":""}},[_c('PeriodLiveView',{attrs:{"months":_vm.months}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }